import { getPlatform } from "./common";
import qs from "qs";
class NATIVE {
  /**
   *
   * @param {*} aFunc 安卓处理函数
   * @param {*} iFunc 苹果系统处理函数
   */
  static trigger(aFunc = () => {}, iFunc = () => {}) {
    if (getPlatform() === "aphone") {
      try {
        aFunc();
      } catch (e) {
        console.log("安卓系统，非APP环境");
      }
    } else if (getPlatform() === "iphone") {
      try {
        iFunc();
      } catch (e) {
        console.log("苹果系统，非APP环境");
      }
    } else {
      console.log("未知系统");
    }
  }
  // app下载文件
  static downloadFile(FileUrl) {
    this.trigger(
      () => {
        window.SpeedBiz.downloadFile(FileUrl);
      },
      () => {
        window.webkit.messageHandlers.downloadFile.postMessage(FileUrl);
      }
    );
  }
  // app发起微信分享
  static shareH5(title, desc, url, thumbnail) {
    this.trigger(
      () => {
        window.SpeedBiz.shareUrl(title, desc, url, thumbnail);
      },
      () => {
        window.webkit.messageHandlers.shareUrl.postMessage(
          JSON.stringify({
            title,
            desc,
            url,
            thumbnail
          })
        );
      }
    );
  }
  // app关闭webview
  static closeH5() {
    this.trigger(
      () => {
        window.SpeedBiz.finishActivity();
      },
      () => {
        window.webkit.messageHandlers.finishActivity.postMessage("");
      }
    );
  }
  // app设置顶部栏的背景颜色
  static setAppTopBarColor(color = "#FFFFFF") {
    this.trigger(
      () => {
        window.SpeedBiz.setStatusBarColor(color);
      },
      () => {
        window.webkit.messageHandlers.setStatusBarColor.postMessage(color);
      }
    );
  }
  // 获取app登录的token
  static getUserAuthToken = () => {
    const parseQuerySearch = () => window.location.search.replace("?", "");
    const qSearch = parseQuerySearch();
    const { token } = qs.parse(qSearch);
    let tokenPromise;
    try {
      if (window.SpeedBiz && getPlatform() === "aphone") {
        tokenPromise = Promise.resolve(window.SpeedBiz.getLocalToken());
      } else if (getPlatform() === "iphone") {
        tokenPromise = new Promise((resolve, reject) => {
          window.getIOSLocalToken = token => {
            resolve(token || "");
          };
        });
        window.webkit.messageHandlers.getLocalToken.postMessage("");
      } else {
        if (token) {
          tokenPromise = Promise.resolve(token);
        } else {
          tokenPromise = Promise.resolve("");
        }
      }
      return tokenPromise;
    } catch (e) {
      return Promise.resolve(token);
    }
  };
  static isAPP() {
    try {
      if (getPlatform() === "aphone") {
        window.SpeedBiz.getLocalToken();
      } else if (getPlatform() === "iphone") {
        window.webkit.messageHandlers.getLocalToken.postMessage("");
      } else {
      }
    } catch (e) {
      return false;
    }
    return true;
  }
  static getAppLanguage() {
    const defaultInfo = navigator.language || "en-US"; // en-US zh-CN
    const languageMap = {
      "zh-CN": "zh-CN",
      "zh-cn": "zh-CN",
      cn: "zh-CN",
      "en-US": "en-US",
      "en-us": "en-US",
      en: "en-US",
      "ms-MY": "ms-MY",
      "ms-my": "ms-MY",
      ms: "ms-MY",
      "th-TH": "th-TH",
      "th-th": "th-TH",
      th: "th-TH",
      "vi-VN": "vi-VN",
      "vi-vn": "vi-VN",
      vi: "vi-VN"
    };
    let languagePromise;
    try {
      if (getPlatform() === "aphone") {
        languagePromise = Promise.resolve(languageMap[window.SpeedBiz.getAppLanguage()] || languageMap[defaultInfo]);
      } else if (getPlatform() === "iphone") {
        languagePromise = new Promise((resolve, reject) => {
          window.getIOSAppLanguage = language => {
            resolve(languageMap[language] || languageMap[defaultInfo]);
          };
        });
        window.webkit.messageHandlers.getAppLanguage.postMessage("");
      } else {
        languagePromise = Promise.resolve(languageMap[defaultInfo]);
      }
    } catch (e) {
      // languagePromise = Promise.resolve("en-US");

      languagePromise = Promise.resolve(languageMap[defaultInfo]);
    }
    return languagePromise;
  }
  static setAddress(addressStr) {
    console.log("addressStr", addressStr);
    this.trigger(
      () => {
        window.SpeedBiz.receiveAddress(addressStr);
      },
      () => {
        window.webkit.messageHandlers.receiveAddress.postMessage(addressStr);
      }
    );
  }
  static getAppCurrencyInfo() {
    const defaultInfo = "￥,元";
    let currencyPromise;
    try {
      if (getPlatform() === "aphone") {
        currencyPromise = Promise.resolve(window.SpeedBiz.getAppCurrencyInfo() || defaultInfo);
      } else if (getPlatform() === "iphone") {
        currencyPromise = new Promise((resolve, reject) => {
          window.getIOSAppCurrencyInfo = language => {
            resolve(language || defaultInfo);
          };
        });
        window.webkit.messageHandlers.getAppCurrencyInfo.postMessage("");
      } else {
        currencyPromise = Promise.resolve(defaultInfo);
      }
    } catch (e) {
      currencyPromise = Promise.resolve(defaultInfo);
    }
    return currencyPromise;
  }
  static saveBase64Pic2Album(base64Str) {
    this.trigger(
      () => {
        window.SpeedBiz.saveBase64Pic2Album(base64Str);
      },
      () => {
        window.webkit.messageHandlers.saveBase64Pic2Album.postMessage(base64Str);
      }
    );
  }
  static getStoreQueryTutorials() {
    let promise;
    const defaultInfo = "{}";
    try {
      if (getPlatform() === "aphone") {
        promise = Promise.resolve(window.SpeedBiz.storeQueryTutorials() || defaultInfo);
      } else if (getPlatform() === "iphone") {
        promise = new Promise((resolve, reject) => {
          window.getIOSStoreTutorials = dataStr => {
            resolve(dataStr || defaultInfo);
          };
        });
        window.webkit.messageHandlers.storeQueryTutorials.postMessage("");
      } else {
        promise = Promise.resolve(defaultInfo);
      }
    } catch (e) {
      promise = Promise.resolve(defaultInfo);
    }
    return promise;
  }
  static msgIntentPage(msgData) {
    const msgStr = msgData ? JSON.stringify(msgData) : "";
    this.trigger(
      () => {
        window.SpeedBiz.msgIntentPage(msgStr);
      },
      () => {
        window.webkit.messageHandlers.msgIntentPage.postMessage(msgStr);
      }
    );
  }
  static callAppScanBar() {
    this.trigger(
      () => {
        window.SpeedBiz.callAppScanBar();
      },
      () => {
        window.webkit.messageHandlers.callAppScanBar.postMessage("");
      }
    );
  }
  // 扫描二维码
  static getScanQRCode = (title = "扫一扫", flashLightTitle = "") => {
    let promise;
    try {
      if (window.SpeedBiz && getPlatform() === "aphone") {
        promise = new Promise(resolve => {
          window.getAppQRCode = text => {
            resolve(text || "");
          };
        });
        window.SpeedBiz.callAppScanQRCode(title, flashLightTitle);
      } else if (getPlatform() === "iphone") {
        promise = new Promise(resolve => {
          window.getAppQRCode = text => {
            resolve(text || "");
          };
        });
        window.webkit.messageHandlers.callAppScanQRCode.postMessage(
          JSON.stringify({
            title,
            flashLightTitle
          })
        );
      } else {
        promise = Promise.resolve("");
      }
      return promise;
    } catch (e) {
      return Promise.reject(new Error("调用APP方法失败"));
    }
  };
  static callAlbumOrTakePhoto() {
    this.trigger(
      () => {
        window.SpeedBiz.callAlbumOrTakePhoto();
      },
      () => {
        console.warn("安卓独有的方法");
      }
    );
  }
  // 获取该门店的品牌
  static getBrand() {
    const defaultBrand = "MIXED"; // 默认就是混合品牌（后端混合返回的空字符串）
    let brandPromise;
    try {
      if (getPlatform() === "aphone") {
        brandPromise = Promise.resolve(window.SpeedBiz.getBrand() || defaultBrand);
      } else if (getPlatform() === "iphone") {
        brandPromise = new Promise((resolve, reject) => {
          window.getIOSBrand = brand => {
            resolve(brand || defaultBrand);
          };
        });
        window.webkit.messageHandlers.getBrand.postMessage("");
      } else {
        brandPromise = Promise.resolve(defaultBrand);
      }
    } catch (e) {
      brandPromise = Promise.resolve(defaultBrand);
    }
    return brandPromise;
  }
}

export default NATIVE;



// WEBPACK FOOTER //
// ./src/utils/native.js